import { useEffect, useRef } from 'react';

import { useGlobalModalLaunchContext } from '../../contexts/modal-context/global-modal-context';
import { useShouldShowPhoneCapture } from './use-should-show-phone-capture';
import { PHONE_CAPTURE_SOURCE } from '../phone-number-capture/constants';

export const useAutoLaunchPhoneCapture = () => {
  const context = useGlobalModalLaunchContext();
  const shouldShow = useShouldShowPhoneCapture();
  const hasLaunchedRef = useRef(false);

  useEffect(() => {
    if (!context) {
      return;
    }

    if (hasLaunchedRef.current) {
      return;
    }

    if (!shouldShow) {
      return;
    }

    const timeoutId = setTimeout(() => {
      hasLaunchedRef.current = true;
      context.openPhoneCaptureModal(PHONE_CAPTURE_SOURCE.AUTO);
    });

    return () => clearTimeout(timeoutId);
  }, [shouldShow, context]);
};
